import React, { Component } from "react";
import { Button, Drawer, notification, Row, Space, Spin, Tabs } from "antd";
import { FormattedMessage, injectIntl } from "react-intl";
import { withTheme } from "styled-components";
import Wrapper from "../components/menu/settings/userDrawer.style";
import AppContext from "../AppContext";
import { invokeApi } from "../helpers/authHelper";
import axios from "axios";
import Header from "../components/menu/settings/header";
import AccessHistoryTable from "../components/accessHistoryTable";
import AvatarUpload from "../components/menu/settings/upload";
import UpdatePassword from "../components/menu/settings/updatePassword";
import Preferences from "../components/menu/settings/preferences";
import moment from "moment";
import UpdateSecurity from "../components/menu/settings/security";

const { TabPane } = Tabs;

class Settings extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      settings_loading: true,
      warningVisible: false,
      contact: null,
      access_history: [],
      upload: false,
      upload_loading: false,
      status: null,
      hover: false,
      passwordEditing: false,
      password_loading: false,
      passwordVisible: false,
      document_preferences: [],
      document_preferences_options: [],
      clients: [],
      allQuestions: [],
      questions_loading: false,
      pages: [],
      user_prefs: {},
      setPreferences: {},
    };
  }

  componentDidMount = () => {
    this.signal = this.context.axiosCancel();
  };

  componentWillUnmount = () => {
    this.signal.cancel();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props?.visible && this.props.visible !== prevProps.visible) {
      if (this.context.user_uuid !== undefined) {
        this.getClientInfo();
        this.getUserPrefs();
        if (!this.state.questions_loading) {
          this.getUserQuestions();
        }
      }
    }
  }

  getUserQuestions = async () => {
    this.setState({ questions_loading: true });
    return await invokeApi({
      path: `/rest/user/sq`,
      method: "GET",
      cancelToken: this.signal.token,
      onSuccess: r => this.handleUserQuestions(r),
      onError: this.handleError,
    });
  };

  getAppVars = async state => {
    return await invokeApi({
      path: `/rest/app/appvar`,
      method: "POST",
      body: {
        key_list: ["risk7.security_questions", "cp.document_delivery_preferences"],
      },
      cancelToken: this.signal.token,
      onSuccess: r => this.handleAppVars(r, state),
      onError: this.handleError,
    });
  };

  getLookups = async state => {
    invokeApi({
      path: `/rest/lookup`,
      method: "GET",
      queryParams: { q: "boolean,dz.pages" },
      cancelToken: this.signal.token,
      onSuccess: r => this.handleLookups(r, state),
    });
  };

  getClientInfo = async () => {
    return await invokeApi({
      path: `/rest/portal/info`,
      method: "POST",
      queryParams: {
        date: moment().format("YYYY-MM-DD"),
      },
      cancelToken: this.signal.token,
      onSuccess: r => this.handleClientInfo(r),
      onError: this.handleError,
    });
  };

  getUserAccessHistory = async state => {
    invokeApi({
      path: `/rest/portal/history`,
      method: "POST",
      cancelToken: this.signal.token,
      onSuccess: r => this.handleAccessHistory(r, state),
      onError: this.handleError,
    });
  };

  getUserPrefs = async () => {
    invokeApi({
      path: `rest/portal/preferences`,
      method: "GET",
      cancelToken: this.signal.token,
      onSuccess: r => this.handleUserPrefs(r),
      onError: this.handleError,
    });
  };

  handleAppVars = (appvars, state) => {
    state.allQuestions = appvars?.[0] ?? [];
    state.document_preferences = appvars?.[1] ?? [];
    this.getLookups(state);
  };

  handleLookups = (lookup, state) => {
    state.document_preferences_options = lookup?.["boolean"] ?? [];
    state.pages = lookup?.["dz.pages"] ?? [];
    this.getUserAccessHistory(state);
  };

  handleUserQuestions = userQuestions => {
    this.setState({ userQuestions: userQuestions, questions_loading: false });
  };

  handleClientInfo = results => {
    let state = {};
    state.contact = results?.[0] ?? [];
    state.clients = results?.[1] ?? [];
    state.settings_loading = false;
    this.getAppVars(state);
  };

  handleAccessHistory = (result, state) => {
    state.access_history = result;
    this.setState(state);
  };

  handleUserPrefs = result => {
    this.setState({
      user_prefs: {
        documentPreferences: result.documentPreferences ?? {},
        languagePreferences: result.languagePreferences ?? {},
      },
      setPreferences: result.setPreferences ?? [],
    });
  };

  handleError = e => {
    if (e.message) {
      notification.error({
        message: this.props.intl.formatMessage({ id: e.message }),
        duration: 5,
      });
    } else {
      console.error(e);
    }
    this.setState({ settings_loading: false });
  };

  onClose = () => {
    if (!this.state.upload_loading && !this.state.password_loading) {
      this.props.closeSettings();
    }
  };

  handleUploadChange = visible => {
    if (this.state.upload !== visible) {
      this.setState({ upload: visible });
    }
  };

  getAvatarStatus = uuid => {
    return invokeApi({
      path: `rest/attachment/${uuid}/status`,
      method: "GET",
      cancelToken: this.signal.token,
    });
  };

  removeAvatar = async uuid => {
    try {
      await invokeApi({
        path: `rest/attachment/${uuid}/archive`,
        method: "GET",
        cancelToken: this.signal.token,
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ status: null });
    }
  };

  prepAvatarUpload = info => {
    return invokeApi({
      path: `rest/portal/avatar`,
      method: "POST",
      cancelToken: this.signal.token,
      body: {
        file_name: info.filename,
        file_type: info.file.type,
        file_size: info.file.size,
      },
    });
  };

  handleAvatarChange = async info => {
    try {
      this.setState({ upload_loading: true });
      let file = info.file;
      let prep_data = await this.prepAvatarUpload(info);
      let options = {
        headers: prep_data?.upload_info?.headers,
      };
      await axios.put(prep_data?.upload_info?.url, file, options);
      let avtr = await this.checkAvatarStatus(prep_data?.attachment_uuid);
      if (avtr === "clean") {
        notification.success({
          message: this.props.intl.formatMessage({ id: "Profile Picture Successfully Uploaded" }),
          duration: 5,
        });
      } else {
        notification.info({
          message: this.context.capitalizeStr(
            this.props.intl.formatMessage({
              id: "image could not be shown at this time, please refresh and try again later",
            })
          ),
          duration: 5,
        });
      }
    } catch (e) {
      if (e.message) {
        notification.error({ message: this.props.intl.formatMessage({ id: e.message }), duration: 5 });
      }
    } finally {
      await this.context.updateUserStatus();
      this.setState({
        upload_loading: false,
        upload: false,
      });
    }
  };

  checkAvatarStatus = async uuid => {
    let i = 0;
    let resp = await this.getAvatarStatus(uuid);
    while (i <= 30 && resp === "pending") {
      await this.sleep(3 * 1000);
      resp = await this.getAvatarStatus(uuid);
      i = i + 3;
    }
    return resp;
  };

  sleep = ms => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  onDelete = async () => {
    this.setState({ upload_loading: true });
    await this.removeAvatar(this.context.user_info?.photo_uuid);
    await this.context.updateUserStatus();
    notification.success({
      message: this.props.intl.formatMessage({ id: "Profile Picture Successfully Removed" }),
      duration: 5,
    });
    this.setState({ upload_loading: false });
  };

  handleSubmissionError = e => {
    if (e.message) {
      if (e.data?.status_code === 403) {
        notification.error({
          message: (
            <div className="text-capitalize-first">
              {this.props.intl.formatMessage({
                id: "too many attempts have been made in a row, log back in.",
              })}
            </div>
          ),
          duration: 5,
        });
        localStorage.removeItem("fef.auth.device");
        this.context.signout_user();
      } else if (e.data?.status_code === 401) {
        notification.error({
          message: (
            <div className="text-capitalize-first">
              {this.props.intl.formatMessage({
                id: "there was a problem with your current password or authorisation.",
              })}
            </div>
          ),
        });
      }
    } else {
      console.error(e);
    }
    this.setState({ saving: false });
  };

  changePassword = async payload => {
    this.setState({ password_loading: true });
    let result = false;
    try {
      result = await invokeApi({
        path: `rest/portal/password`,
        method: "POST",
        cancelToken: this.signal.token,
        body: payload,
        onError: this.handleSubmissionError,
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ status: null, password_loading: false });
    }
    return result;
  };

  changeSQ = async payload => {
    this.setState({ password_loading: true });
    let result = false;
    try {
      result = await invokeApi({
        path: `rest/portal/sq`,
        method: "POST",
        cancelToken: this.signal.token,
        body: payload,
        onError: this.handleSubmissionError,
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ status: null, password_loading: false });
    }
    return result;
  };

  changePreferences = async payload => {
    this.setState({ password_loading: true });
    let result = false;
    try {
      result = await invokeApi({
        path: `rest/portal/preferences`,
        method: "POST",
        cancelToken: this.signal.token,
        body: payload,
        onError: this.handleSubmissionError,
      });
      this.setState({
        user_prefs: { ...this.state.user_prefs, ...payload },
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ status: null, password_loading: false });
    }
    return result;
  };

  handleTabChange = tab => {
    if (tab === "password") {
      this.setState({ passwordVisible: true });
    } else if (this.state.passwordVisible) {
      this.setState({ passwordVisible: false });
    }
    if (tab === "security") {
      this.setState({ securityVisible: true });
    } else if (this.state.securityVisible) {
      this.setState({ securityVisible: false });
    }
  };

  render = () => {
    return (
      <Drawer
        visible={this.props.visible}
        onClose={this.onClose}
        title={
          <div className="header2 text-capitalize">
            <FormattedMessage id="settings" />
          </div>
        }
        destroyOnClose={true}
        bodyStyle={{ paddingTop: "1em" }}
        width={window?.innerWidth >= 600 ? "600px" : window?.innerWidth + "px" ?? "360px"}
        footer={
          <Row justify="end" id="settingsDrawerFooter">
            <Space align="center">
              <Button onClick={this.onClose} disabled={this.state.upload_loading || this.state.password_loading}>
                <div className="text-capitalize">
                  <FormattedMessage id="close" />
                </div>
              </Button>
            </Space>
          </Row>
        }
      >
        <Wrapper delete_active={(this.context.user_info?.photo_url ?? "") !== ""} hover={this.state.hover}>
          <Spin
            spinning={this.state.settings_loading || this.state.upload_loading || this.state.questions_loading}
            wrapperClassName="settingsSpin"
          >
            <Header
              onDelete={() => this.onDelete()}
              contact_info={this.state?.contact?.attrs}
              changeUpload={visible => this.handleUploadChange(visible)}
              uploadVisible={this.state.upload}
              setButtonHover={hover => this.setState({ hover: hover })}
            />
            {this.state.upload ? (
              <AvatarUpload
                upload_loading={this.state.upload_loading}
                handleChange={info => this.handleAvatarChange(info)}
                removeAvatar={uuid => this.removeAvatar(uuid)}
                onDelete={this.onDelete}
                handleUploadChange={visible => this.handleUploadChange(visible)}
              />
            ) : (
              <Tabs className="tabContainer" onChange={this.handleTabChange}>
                <TabPane
                  tab={
                    <div className="text-capitalize">
                      <FormattedMessage id="activity" />
                    </div>
                  }
                  key="activity"
                >
                  <AccessHistoryTable loginHistory={this.state.access_history} isLoading={false} />
                </TabPane>
                <TabPane
                  tab={
                    <div className="text-capitalize">
                      <FormattedMessage id="password" />
                    </div>
                  }
                  key="password"
                >
                  <UpdatePassword
                    questions={this.state.userQuestions}
                    changePassword={payload => this.changePassword(payload)}
                    reset={!this.state.passwordVisible}
                  />
                </TabPane>
                <TabPane
                  tab={
                    <div className="text-capitalize">
                      <FormattedMessage id="security" />
                    </div>
                  }
                  key="security"
                >
                  <UpdateSecurity
                    userQuestions={this.state?.userQuestions}
                    changeSQ={payload => this.changeSQ(payload)}
                    allQuestions={this.state?.allQuestions}
                    reset={this.state.securityVisible}
                    reloadUserQuestions={this.getUserQuestions}
                  />
                </TabPane>
                <TabPane
                  tab={
                    <div className="text-capitalize">
                      <FormattedMessage id="preferences" />
                    </div>
                  }
                  key="preferences"
                >
                  <Preferences
                    clients={this.state.clients}
                    changePreferences={payload => this.changePreferences(payload)}
                    document_preferences={this.state.document_preferences}
                    document_options={this.state.document_preferences_options}
                    pages={this.state.pages}
                    user_prefs={this.state.user_prefs}
                    setPreferences={this.state.setPreferences}
                  />
                </TabPane>
              </Tabs>
            )}
          </Spin>
        </Wrapper>
      </Drawer>
    );
  };
}

export default withTheme(injectIntl(Settings));
